import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HiOutlineDeviceMobile } from 'react-icons/hi';

import LogoBlack from 'assets/images/logo_black.png';
import LogoWhite from 'assets/images/logo_white.png';
import LogoSingle from 'assets/images/pmix-logo-single.svg';
import { useSelector } from 'react-redux';
import CurrencyDropdown from 'ui-component/currency-dropdown/CurrencyDropdown';
import {
	ContactsIcons,
	DashboardIcon,
	OperationsIcon,
	OrdersIcon,
	PurchaseListIcon,
	CreditNoteIcon,
	SerialsIcon,
	SettingsIcon,
	ShipmentIcon,
	ReportContactExpenseIcon,
	SalesOrderIcon,
	InvoiceIcon,
	QuotationIcon,
	ShoppingBagIcon,
	ReportProfitLossIcon,
	SettingsUsersIcon,
	DayCalendarIcon,
} from 'ui-component/custom-icons/icons';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { TbReportAnalytics } from 'react-icons/tb';
import { RiBuildingLine } from 'react-icons/ri';

import { FaChevronLeft, FaChevronRight, FaRegClock, FaChevronDown, FaChevronUp } from 'react-icons/fa6';

// ==============================|| SIDEBAR DRAWER ||============================== //
// ✅ Clear
const Sidebar = ({ mobile, mobileShowMenu, closeMobileMenu }) => {
	const history = useNavigate();
	const { pathname } = useLocation();
	const [show, setShow] = useState('');
	const [isOpened, setIsOpened] = useState(true);
	const displayTheme = useSelector((state) => state.main.displayTheme);
	const compRef = useRef(null);
	const [showSalesSubmenu, setShowSalesSubmenu] = useState(false);
	const [showPurchasesSubmenu, setShowPurchasesSubmenu] = useState(false);
	const [showReportsSubmenu, setShowReportsSubmenu] = useState(false);
	const [logoInDarkMode, setLogoInDarkMode] = useState(false);

	useEffect(() => {
	
		setShow('');
	}, [pathname, isOpened]);

	useEffect(() => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		}

		
	}, []);

	useEffect(() => {

		const getDarkMode = localStorage.getItem('displayTheme');
		if (!getDarkMode) {
		} else {
			if (getDarkMode === 'lightMode') {
				setLogoInDarkMode(false);
			} else {
				setLogoInDarkMode(true);
			}
		}
	}, [displayTheme]);

	useEffect(() => {
		if (show == '' && mobile) {
			closeMobileMenu && closeMobileMenu();
		}
	}, [show, mobile]);

	const handleResize = () => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		} else if (window.innerWidth > 1150) {
			setIsOpened(true);
		}
	};

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (compRef.current && !compRef.current.contains(event.target)) {
			setShow('');
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);

		if (pathname.includes('/sales/invoices') || pathname.includes('/sales/quotations') || pathname.includes('/sales/sales-orders')) {
			setShowSalesSubmenu(true);
			setShowPurchasesSubmenu(false)
			setShowReportsSubmenu(false)
		} 
		if (pathname.includes('/purchasing') || pathname.includes('/bills') || pathname.includes('/payments-made') || pathname.includes('/vendor-credits')) {
			setShowSalesSubmenu(false);
			setShowPurchasesSubmenu(true)
			setShowReportsSubmenu(false)
		}
		if (pathname.includes('/reports') || pathname.includes('/reports/profit-loss-statement')) {
			setShowSalesSubmenu(false);
			setShowPurchasesSubmenu(false)
			setShowReportsSubmenu(true)
		}

		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	    const sidebarRef = useRef(null);

			useEffect(() => {
				if (!mobileShowMenu || !mobile) return;

				const handleClickOutside = (event) => {
					if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
						closeMobileMenu && closeMobileMenu();
					}
				};

				document.addEventListener('mousedown', handleClickOutside);
				return () => {
					document.removeEventListener('mousedown', handleClickOutside);
				};
			}, [mobileShowMenu, mobile, closeMobileMenu]);

	return (
		<>
			{show && <div className="nav-opacity-bg" >&nbsp;</div>}
			<div
			   ref={sidebarRef}
				className={`new-nav-bar ${mobile ? 'mobile-menu' : ''} ${isOpened || mobile ? 'expanded' : 'collapsed'} ${mobileShowMenu ? 'show-mobile' : ''
					}`}
			>
				{!mobile && (
					<div className="nav-brand-logo">
						<Link className="sidebar-brand d-flex align-items-center justify-content-center" to={'/dashboard'}>
							<div className="sidebar-brand-text" onClick={() => history('/dashboard')}>
								{isOpened ? (
									<img src={logoInDarkMode ? LogoWhite : LogoBlack} alt="logo" className="img-fluid" width={150} />
								) : (
									<img src={LogoSingle} alt="logo" className="img-fluid" width={40} />
								)}
							</div>
						</Link>
					</div>
				)}

				<ul className="navbar-nav-items" ref={compRef}>
					<li className={`nav-item main-menu mt-2 ${pathname === '/dashboard' ? 'active' : ''}`}>
						<Link
							to={'/dashboard'}
							className="nav-link"
							onClick={() => {
								mobile && closeMobileMenu && closeMobileMenu();
							}}
						>
							<span className="menuIcon">
								<DashboardIcon width="14" height="14" />
							</span>
							<span className="menuLabel"><div>Dashboard</div></span>
						</Link>
					</li>

					<li className="nav-break">&nbsp;</li>

				

					<li className={`nav-item main-menu ${pathname.includes('/users') ? 'active' : ''}`}>
						<Link
							to={'/users'}
							className={`nav-link`}
							onClick={() => {
								setShowSalesSubmenu(false);
								setShowPurchasesSubmenu(false)
								setShowReportsSubmenu(false);
							}}
						>
							<span className="menuIcon">
								<SettingsUsersIcon width="16" height="16" />
							</span>
							<span className="menuLabel">
								<div className="sidebar-title-backside"></div><div>Members</div>
							</span>
						</Link>
					</li>
					<li className={`nav-item main-menu ${pathname.includes('/events') ? 'active' : ''}`}>
						<Link
							to={'/events'}
							className={`nav-link`}
							onClick={() => {
								setShowSalesSubmenu(false);
								setShowPurchasesSubmenu(false)
								setShowReportsSubmenu(false);
							}}
						>
							<span className="menuIcon">
								<DayCalendarIcon width="16" height="16" />
							</span>
							<span className="menuLabel">
								<div className="sidebar-title-backside"></div><div>Events</div>
							</span>
						</Link>
					</li>


					<li className="nav-break">&nbsp;</li>

					<li className={`nav-item main-menu hide-on-mobile ${pathname.includes('settings') ? 'active' : ''}`}>
						<Link
							to={'/settings'}
							className={`nav-link`}
							onClick={() => {
								mobile && closeMobileMenu && closeMobileMenu();
								setShowSalesSubmenu(false);
								setShowPurchasesSubmenu(false)
							}}
						>
							<span className="menuIcon">
								<SettingsIcon width="16" height="16" />
							</span>
							<span className="menuLabel"><div>Time Keeping</div></span>
						</Link>
					</li>

				</ul>
				<div className="currency-div">
					{/* <CurrencyDropdown isOpen={mobile ? true : isOpened} /> */}

					{!mobile && (
						<div
							className="collapse-tag"
							onClick={() => {
								setIsOpened(!isOpened);
							}}
						>
							{isOpened ? <FaChevronLeft /> : <FaChevronRight />}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Sidebar;
